(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["toni-cart-pair"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('toni-cart-pair')) return;

  const key = 'toni-cart-pair-v1';
  const instances = new Set();
  let state = { closed: false, choice: null };
  let busy = false;
  let preferredProductId = null;
  let terminalMessage = '';
  let terminalCartUrl = null;

  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved) state = { closed: saved.closed === true, choice: typeof saved.choice === 'string' ? saved.choice : null };
  } catch (_) {}

  const save = () => {
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
  };
  const identity = (candidate) => `${candidate.ruleId}:${candidate.variantId}`;
  const refresh = () => instances.forEach((instance) => instance.render());
  const readPayload = (element) => {
    try {
      const payload = JSON.parse(element.getAttribute('data-payload') || '{}');
      return { ...payload, labels: payload.labels || {}, candidates: Array.isArray(payload.candidates) ? payload.candidates : [] };
    } catch (_) { return { labels: {}, candidates: [] }; }
  };
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text != null) element.textContent = text;
    return element;
  };
  const sameOriginUrl = (value) => {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid cart URL');
    return url;
  };
  const getJson = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options });
    if (!response.ok) throw new Error('Request failed');
    return response.json();
  };
  const sectionIds = () => [...new Set([...document.querySelectorAll('cart-items-component')]
    .map((element) => element.dataset.sectionId).filter(Boolean))].slice(0, 5);
  const sectionDocuments = (sections) => Object.values(sections || {})
    .filter((html) => typeof html === 'string')
    .map((html) => new DOMParser().parseFromString(html, 'text/html'));
  const getCount = (sections) => {
    for (const doc of sectionDocuments(sections)) {
      const element = doc.querySelector('[ref="cartItemCount"]');
      if (!element) continue;
      const count = Number(element.textContent.trim());
      if (Number.isInteger(count) && count >= 0) return count;
    }
    return null;
  };
  const notifyCart = async (payload, resource, sections) => {
    let count = getCount(sections);
    if (count == null) {
      const url = sameOriginUrl(payload.cartUrl);
      url.pathname = `${url.pathname.replace(/\/$/, '').replace(/\.js$/, '')}.js`;
      const cart = await getJson(url);
      count = cart.item_count;
      if (!Number.isInteger(count) || count < 0) throw new Error('Cart count unavailable');
    }
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource, sourceId: 'toni-cart-pair', data: { source: 'toni-cart-pair', sections, itemCount: count } },
    }));
  };

  document.addEventListener('cart:update', (event) => {
    const data = event.detail?.data;
    if (data?.source === 'product-form-component' && !data.didError && data.productId) {
      preferredProductId = String(data.productId);
    }
    queueMicrotask(() => {
      refresh();
      preferredProductId = null;
    });
  }, true);

  class ToniCartPair extends HTMLElement {
    static observedAttributes = ['data-payload'];

    connectedCallback() {
      instances.add(this);
      this.render();
    }

    disconnectedCallback() { instances.delete(this); }

    attributeChangedCallback() {
      if (this.isConnected) queueMicrotask(() => this.render());
    }

    render() {
      const payload = readPayload(this);
      const labels = payload.labels;
      this.replaceChildren();
      if (state.closed) {
        if (terminalMessage) {
          const status = make('p', 'toni-pair__status', terminalMessage);
          status.setAttribute('role', 'status');
          this.append(status);
          if (terminalCartUrl) {
            const link = make('a', 'toni-pair__title', labels.viewCart || 'Avaa ostoskori');
            link.href = terminalCartUrl;
            this.append(link);
          }
        }
        return;
      }
      const candidates = payload.candidates;
      let choice = candidates.find((candidate) => identity(candidate) === state.choice);
      if (!choice && preferredProductId) {
        choice = candidates.find((candidate) => candidate.sourceProductIds?.map(String).includes(preferredProductId));
      }
      if (!choice && !state.choice && !preferredProductId) choice = candidates[0];
      if (!choice) return;
      if (identity(choice) !== state.choice) {
        state.choice = identity(choice);
        preferredProductId = null;
        save();
      }
      const heading = make('h3', 'toni-pair__heading', labels.heading);
      const dismiss = make('button', 'toni-pair__dismiss', '×');
      dismiss.type = 'button';
      dismiss.setAttribute('aria-label', labels.dismiss || 'Sulje suositus');
      dismiss.disabled = busy;
      dismiss.addEventListener('click', (event) => { event.stopPropagation(); state.closed = true; save(); refresh(); });
      const header = make('div', 'toni-pair__header');
      header.append(heading, dismiss);
      const product = make('div', 'toni-pair__product');
      if (choice.image) {
        const image = make('img', 'toni-pair__image');
        image.src = choice.image;
        image.alt = '';
        image.width = 40;
        image.height = 40;
        image.loading = 'lazy';
        product.append(image);
      }
      const content = make('div', 'toni-pair__content');
      const title = make('a', 'toni-pair__title', choice.title);
      try { title.href = sameOriginUrl(choice.url).href; } catch (_) { return; }
      content.append(title, make('p', 'toni-pair__reason', choice.reason));
      const add = make('button', 'toni-pair__add', busy ? labels.adding : labels.add);
      add.type = 'button';
      add.disabled = busy;
      add.setAttribute('aria-busy', String(busy));
      add.addEventListener('click', (event) => { event.stopPropagation(); this.add(choice, payload); });
      const actions = make('div', 'toni-pair__actions');
      actions.append(make('span', 'toni-pair__price', choice.price), add);
      product.append(content);
      this.append(header, product, actions);
      if (this.message) {
        const status = make('p', 'toni-pair__status', this.message);
        status.setAttribute('role', 'status');
        this.append(status);
      }
    }

    async add(choice, payload) {
      if (busy || state.closed) return;
      busy = true;
      this.message = '';
      refresh();
      let posted = false;
      try {
        const ids = sectionIds();
        if (!ids.length) throw new Error('Cart section unavailable');
        const url = sameOriginUrl(location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.delete('section_id');
        const sectionsUrl = `${url.pathname}${url.search}`;
        url.searchParams.set('sections', ids.join(','));
        const sections = await getJson(url);
        const freshElements = sectionDocuments(sections).flatMap((doc) =>
          [...doc.querySelectorAll('toni-cart-pair[data-payload]')]);
        if (!freshElements.length) throw new Error('Recommendation check unavailable');
        const candidates = freshElements.flatMap((element) => readPayload(element).candidates);
        if (!candidates.some((candidate) => identity(candidate) === identity(choice))) {
          this.replaceChildren();
          state.closed = true;
          save();
          await notifyCart(payload, {}, sections);
          return;
        }
        const addUrl = sameOriginUrl(payload.addUrl);
        posted = true;
        const response = await fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: choice.variantId, quantity: 1 }], sections: ids, sections_url: sectionsUrl }),
        });
        const resource = await response.json();
        state.closed = true;
        save();
        if (!response.ok || resource.status) {
          terminalMessage = payload.labels.uncertain || 'Tarkista ostoskori ennen uutta lisäystä.';
          terminalCartUrl = sameOriginUrl(payload.cartUrl).href;
          await notifyCart(payload, resource, undefined);
          return;
        }
        terminalMessage = payload.labels.added || '';
        refresh();
        await notifyCart(payload, resource, resource.sections);
        setTimeout(() => { terminalMessage = ''; refresh(); }, 5000);
      } catch (_) {
        if (posted) {
          state.closed = true;
          save();
          terminalMessage = payload.labels.uncertain || 'Tarkista ostoskori ennen uutta lisäystä.';
          terminalCartUrl = sameOriginUrl(payload.cartUrl).href;
          try { await notifyCart(payload, {}, undefined); } catch (_) {}
        } else {
          this.message = payload.labels.error || 'Lisääminen ei onnistunut. Yritä hetken kuluttua uudelleen.';
        }
      } finally {
        busy = false;
        refresh();
      }
    }
  }

  customElements.define('toni-cart-pair', ToniCartPair);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toni-cart-shipping-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('toni-cart-shipping')) return;

  const instances = new Set();
  const cache = new Map();
  const postcodes = new Map();
  const storageKey = 'toni-cart-shipping-postcodes-v1';
  const validPostcode = (value) => typeof value === 'string' && value === value.trim() && /^[A-Za-z0-9 -]{1,16}$/.test(value);
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
      for (const [country, zip] of Object.entries(saved).slice(0, 32)) {
        if (/^[A-Z]{2}$/.test(country) && validPostcode(zip)) postcodes.set(country, zip);
      }
    }
  } catch {}
  const rememberPostcode = (country, zip) => {
    postcodes.set(country, zip);
    if (postcodes.size > 32) postcodes.delete(postcodes.keys().next().value);
    try { sessionStorage.setItem(storageKey, JSON.stringify(Object.fromEntries(postcodes))); } catch {}
  };
  const active = new Set();
  let generation = 0;
  let pendingCart = false;
  let pendingTimer;
  let queue = Promise.resolve();
  let nextId = 0;

  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const read = (element) => {
    try {
      const value = JSON.parse(element.getAttribute('data-payload') || '{}');
      if (!/^[A-Z]{2}$/.test(value.country) || !/^[A-Z]{3}$/.test(value.currency)) return null;
      if (!Number.isSafeInteger(value.total) || value.total < 0 || !Number.isSafeInteger(value.count) || value.count < 0) return null;
      if (typeof value.fingerprint !== 'string' || !value.fingerprint || !value.labels) return null;
      return value;
    } catch { return null; }
  };
  const money = (amount, payload) => new Intl.NumberFormat(payload.language || 'fi', {
    style: 'currency', currency: payload.currency,
  }).format(amount / 100);
  const domesticQuote = (payload) => {
    const rule = payload.domesticRates;
    if (payload.country !== 'FI' || payload.currency !== 'EUR' || payload.shopCurrency !== 'EUR' || !rule || rule.currency !== 'EUR') return null;
    if (![rule.threshold, rule.standard, rule.reduced].every(value => Number.isSafeInteger(value) && value >= 0)) return null;
    if (rule.threshold === 0 || rule.reduced > rule.standard || typeof rule.name !== 'string' || !rule.name.trim()) return null;
    return { price: payload.total >= rule.threshold ? rule.reduced : rule.standard, name: rule.name, from: false, fixed: true };
  };
  const cents = (value) => {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    const text = String(value);
    if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null;
    const [whole, fraction = ''] = text.split('.');
    const result = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
    return Number.isSafeInteger(result) && result >= 0 ? result : null;
  };
  const rates = (body, payload) => {
    if (!body || !Array.isArray(body.shipping_rates)) throw new Error('Invalid shipping response');
    if (!body.shipping_rates.length) return null;
    const parsed = body.shipping_rates.map((rate) => {
      if (!rate || typeof rate !== 'object') throw new Error('Invalid rate');
      const currency = rate.currency == null || rate.currency === ''
        ? (payload.currency === payload.shopCurrency ? payload.shopCurrency : null)
        : String(rate.currency).toUpperCase();
      const price = cents(rate.price);
      const name = rate.presentment_name || rate.name;
      if (currency !== payload.currency || price === null || typeof name !== 'string' || !name.trim()) throw new Error('Invalid rate');
      return { price, name: name.trim() };
    }).sort((a, b) => a.price - b.price);
    return { ...parsed[0], from: parsed.length > 1 };
  };
  const keyFor = (payload, zip) => JSON.stringify([
    payload.fingerprint, payload.total, payload.count, payload.country, payload.currency, payload.shopCurrency, zip,
  ]);
  const endpoint = (payload, route, zip) => {
    const url = new URL(payload.cartUrl, location.origin);
    if (url.origin !== location.origin || !/\/cart\/?$/.test(url.pathname)) throw new Error('Invalid cart URL');
    url.pathname = `${url.pathname.replace(/\/$/, '')}/${route}.json`;
    url.search = '';
    url.hash = '';
    url.searchParams.set('shipping_address[country]', payload.country);
    if (zip) url.searchParams.set('shipping_address[zip]', zip);
    return url;
  };
  const delay = (duration, signal) => new Promise((resolve, reject) => {
    if (signal.aborted) { reject(new Error('Cancelled')); return; }
    const abort = () => { clearTimeout(timer); reject(new Error('Cancelled')); };
    const timer = setTimeout(() => { signal.removeEventListener('abort', abort); resolve(); }, duration);
    signal.addEventListener('abort', abort, { once: true });
  });
  const request = async (url, method, signal) => {
    const response = await fetch(url, { method, credentials: 'same-origin', signal, headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Shipping ${response.status}`);
    const body = await response.text();
    if (!body.trim()) return null;
    return JSON.parse(body);
  };
  const loadQuote = async (payload, zip, version) => {
    if (version !== generation || pendingCart) throw new Error('Cancelled');
    const controller = new AbortController();
    active.add(controller);
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      await request(endpoint(payload, 'prepare_shipping_rates', zip), 'POST', controller.signal);
      for (let attempt = 0; attempt < 5; attempt++) {
        if (version !== generation || pendingCart || controller.signal.aborted) throw new Error('Cancelled');
        if (attempt) await delay(attempt * 400, controller.signal);
        const body = await request(endpoint(payload, 'async_shipping_rates', zip), 'GET', controller.signal);
        if (version !== generation || pendingCart) throw new Error('Cancelled');
        if (body !== null) return rates(body, payload);
      }
      throw new Error('Shipping timeout');
    } finally {
      clearTimeout(timeout);
      active.delete(controller);
    }
  };
  const quote = (payload, zip) => {
    const key = keyFor(payload, zip);
    const existing = cache.get(key);
    if (existing && existing.expires > Date.now()) return existing.promise;
    const version = generation;
    const entry = { expires: Date.now() + 120000, promise: null };
    const task = queue.catch(() => {}).then(() => loadQuote(payload, zip, version));
    queue = task.catch(() => {});
    entry.promise = task.catch((error) => { entry.expires = Date.now() + 15000; throw error; });
    cache.set(key, entry);
    if (cache.size > 20) cache.delete(cache.keys().next().value);
    return entry.promise;
  };
  const invalidate = (waitForCart = false) => {
    generation++;
    cache.clear();
    for (const controller of active) controller.abort();
    pendingCart = waitForCart;
    clearTimeout(pendingTimer);
    for (const element of instances) element.schedule(waitForCart);
    if (waitForCart) pendingTimer = setTimeout(() => {
      for (const element of instances) element.showUnavailable();
    }, 15000);
  };

  class ToniCartShipping extends HTMLElement {
    static get observedAttributes() { return ['data-payload']; }

    connectedCallback() {
      instances.add(this);
      const dialog = this.closest('dialog');
      if (dialog) {
        this.visibilityObserver = new MutationObserver(() => { if (dialog.open) this.schedule(); });
        this.visibilityObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      }
      this.schedule();
    }

    disconnectedCallback() {
      instances.delete(this);
      clearTimeout(this.timer);
      this.visibilityObserver?.disconnect();
      this.version = (this.version || 0) + 1;
    }

    attributeChangedCallback(name, before, after) {
      if (this.isConnected && before !== after) invalidate();
    }

    output() {
      return this.querySelector('[data-shipping-output]');
    }

    state(value, ready = false) {
      this.setAttribute('data-state', value);
      if (ready) this.setAttribute('data-ready', '');
      else this.removeAttribute('data-ready');
      this.setAttribute('aria-busy', value === 'loading' ? 'true' : 'false');
    }

    schedule(waitForCart = pendingCart) {
      clearTimeout(this.timer);
      this.version = (this.version || 0) + 1;
      if (!this.isConnected) return;
      const payload = read(this);
      this.state('loading');
      this.output()?.replaceChildren(node('p', 'toni-shipping__status', payload?.labels.loading || ''));
      if (!waitForCart) this.timer = setTimeout(() => this.update(), 80);
    }

    showUnavailable() {
      clearTimeout(this.timer);
      this.version = (this.version || 0) + 1;
      const payload = read(this);
      this.state('unavailable');
      this.output()?.replaceChildren(node('p', 'toni-shipping__status', payload?.labels.error || ''));
    }

    postal(payload, failed = false) {
      const details = node('details', 'toni-shipping__details');
      const summary = node('summary', 'toni-shipping__summary', failed ? payload.labels.needPostal : payload.labels.change);
      const controls = node('div', 'toni-shipping__controls');
      const label = node('label', 'toni-shipping__postal-label', payload.labels.postal);
      const input = node('input', 'toni-shipping__postal');
      input.id = `toni-shipping-postal-${++nextId}`;
      input.type = 'text';
      input.autocomplete = 'postal-code';
      input.maxLength = 16;
      input.value = postcodes.get(payload.country) || '';
      label.htmlFor = input.id;
      const button = node('button', 'toni-shipping__calculate', payload.labels.calculate);
      button.type = 'button';
      const calculate = (event) => {
        event.stopPropagation();
        event.preventDefault();
        const zip = input.value.trim().slice(0, 16);
        if (!validPostcode(zip)) { input.focus(); return; }
        rememberPostcode(payload.country, zip);
        invalidate();
      };
      button.addEventListener('click', calculate);
      input.addEventListener('keydown', (event) => { if (event.key === 'Enter') calculate(event); });
      label.append(input);
      controls.append(label, button);
      details.append(summary, controls);
      return details;
    }

    row(label, value, extra = '') {
      const row = node('div', `toni-shipping__row${extra ? ` ${extra}` : ''}`);
      row.append(node('span', 'toni-shipping__label', label), node('strong', 'toni-shipping__price', value));
      return row;
    }

    showQuote(payload, rate) {
      const output = this.output();
      if (!output) return;
      const labels = payload.labels;
      const price = rate.price === 0 && !rate.from ? labels.free : money(rate.price, payload);
      const amount = rate.from ? `${labels.from} ${price}` : price;
      const result = [
        this.row(`${labels.shipping} · ${payload.countryName || payload.country}`, amount),
        node('p', 'toni-shipping__method', rate.name),
      ];
      if (payload.taxesIncluded === true && Number.isSafeInteger(payload.total + rate.price)) {
        result.push(this.row(rate.from ? labels.totalFrom : labels.total, money(payload.total + rate.price, payload), 'toni-shipping__total'));
      }
      const tax = payload.taxesIncluded === true ? labels.taxIncluded : labels.taxExcluded;
      result.push(node('p', 'toni-shipping__note', [tax, rate.fixed ? '' : labels.methodNote].filter(Boolean).join(' ')));
      if (!rate.fixed) result.push(this.postal(payload));
      this.state('ready', true);
      output.replaceChildren(...result);
    }

    async update() {
      if (!this.isConnected || pendingCart) return;
      const dialog = this.closest('dialog');
      if (dialog && !dialog.open) return;
      const output = this.output();
      const payload = read(this);
      if (!output || !payload) { this.state('unavailable'); return; }
      const version = this.version;
      const globalVersion = generation;
      if (!payload.count) { this.state('empty'); output.replaceChildren(); return; }
      if (payload.requiresShipping === false) {
        this.state('digital', true);
        const tax = payload.taxesIncluded === true ? payload.labels.taxIncluded : payload.labels.taxExcluded;
        output.replaceChildren(this.row(payload.labels.shipping, payload.labels.noShipping), node('p', 'toni-shipping__note', tax || ''));
        return;
      }
      const domestic = domesticQuote(payload);
      if (domestic) { this.showQuote(payload, domestic); return; }
      const current = () => this.isConnected && version === this.version && globalVersion === generation && !pendingCart;
      const zip = postcodes.get(payload.country) || '';
      try {
        const rate = await quote(payload, zip);
        if (!current()) return;
        if (rate) this.showQuote(payload, rate);
        else {
          this.state('unavailable');
          output.replaceChildren(...(zip ? [node('p', 'toni-shipping__status', payload.labels.unavailable)] : []), this.postal(payload, true));
        }
      } catch {
        if (!current()) return;
        this.state('postal');
        output.replaceChildren(...(zip ? [node('p', 'toni-shipping__status', payload.labels.error)] : []), this.postal(payload, true));
      }
    }
  }

  document.addEventListener('cart:update', () => invalidate());
  document.addEventListener('discount:update', () => invalidate());
  document.addEventListener('quantity-selector:update', (event) => {
    if (event.detail?.cartLine) invalidate(true);
  });
  document.addEventListener('cart:error', () => {
    clearTimeout(pendingTimer);
    for (const element of instances) element.showUnavailable();
  });
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target instanceof Element && target.matches('input[name="updates[]"]') && target.closest('cart-items-component')) invalidate(true);
  }, true);
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('button');
    if (!button || !button.closest('cart-items-component')) return;
    const action = button.getAttribute('on:click') || '';
    if (/remove|decrease|increase/i.test(action) || button.closest('quantity-selector-component')) invalidate(true);
  }, true);
  customElements.define('toni-cart-shipping', ToniCartShipping);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toni-radar-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('toni-radar-choice')) {
    customElements.define('toni-radar-choice', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.controls = this.querySelector('[data-controls]');
        this.priorities = this.querySelector('[data-priorities]');
        this.automaticOption = this.querySelector('[data-computer-option]');
        this.automaticInput = this.automaticOption.querySelector('input');
        this.results = Array.from(this.querySelectorAll('[data-result]'));
        this.extra = this.querySelector('[data-extra]');
        this.resetButton = this.querySelector('[data-reset]');
        this.status = this.querySelector('[data-status]');
        this.controls.hidden = false;
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-device], [data-priority]')) this.update();
        });
        this.resetButton.addEventListener('click', () => {
          this.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = false; });
          this.querySelectorAll('details').forEach((detail) => { detail.open = false; });
          this.update();
          this.querySelector('[data-device]').focus({ preventScroll: true });
        });
        this.update(false);
      }

      update(announce = true) {
        const device = this.querySelector('[data-device]:checked')?.value;
        const phone = device === 'phone';
        this.priorities.hidden = !device;
        this.automaticOption.hidden = phone;
        this.automaticInput.disabled = phone;
        if (phone) this.automaticInput.checked = false;
        this.querySelectorAll('[data-device-hint]').forEach((hint) => {
          hint.hidden = hint.dataset.deviceHint !== device;
        });
        const priority = this.querySelector('[data-priority]:checked')?.value;
        const model = device ? { everyday: 'magene', battery: 'cycplus', automatic: 'wahoo' }[priority] : null;
        let activeResult = null;
        this.results.forEach((result) => {
          result.hidden = result.dataset.result !== model;
          if (!result.hidden) activeResult = result;
        });
        this.extra.hidden = !activeResult;
        this.querySelector('[data-phone-details]').hidden = !phone;
        this.querySelector('[data-tests]').hidden = model === 'wahoo';
        this.querySelector('[data-wahoo-details]').hidden = model !== 'wahoo';
        this.resetButton.hidden = !device;
        if (announce) this.status.textContent = activeResult ? activeResult.dataset.announcement : this.status.dataset.empty;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
